const FilterActionTypes = {
    CLEAR_ALL_FILTERS: 'CLEAR_ALL_FILTERS',
    UPDATE_PROJECTS_FILTER_APPLIED: 'UPDATE_PROJECTS_FILTER_APPLIED',
    UPDATE_PROJECTS_FILTER_OPTIONS_TOTAL: 'UPDATE_PROJECTS_FILTER_OPTIONS_TOTAL',
    UPDATE_PROJECTS_FILTER_CONJUNCTION_SELECTION: ' UPDATE_PROJECTS_FILTER_CONJUNCTION_SELECTION',
    CREATE_PROJECT_DROPDOWNS: 'CREATE_PROJECT_DROPDOWNS',
    UPDATE_TASKS_FILTER_APPLIED: 'UPDATE_TASKS_FILTER_APPLIED',
    UPDATE_TASKS_FILTER_OPTIONS_TOTAL: 'UPDATE_TASKS_FILTER_OPTIONS_TOTAL',
    UPDATE_TASKS_FILTER_CONJUNCTION_SELECTION: 'UPDATE_TASKS_FILTER_CONJUNCTION_SELECTION',
    CREATE_TASK_DROPDOWNS: 'CREATE_TASK_DROPDOWNS',
}

export default FilterActionTypes;